<template>
  <div class="h-full">
    <transition
      name="fade-transform"
      mode="out-in"
    >
      <common-table
        v-show="pageData.viewMode==='list'"
        ref="table"
      />
    </transition>
    <transition
      name="fade-transform"
      mode="out-in"
    >
      <common-form
        v-show="pageData.viewMode==='info'"
        ref="form"
        @success="updateTable"
      >
        <template #form-bottom>
          <slot name="form-bottom" />
        </template>
      </common-form>
    </transition>
  </div>
</template>

<script>
import CommonTable from "@/components/TkCommonPage/components/CommonTable.vue"
import CommonForm from "@/components/TkCommonPage/components/CommonForm.vue"

export default {
  name: "FormPage",
  components: { CommonForm, CommonTable },
  inject: ["pageData"],
  methods: {
    /**
     * 更新表单
     * @param key
     * @param value
     */
    updateFormData(key, value) {
      this.$refs.form.updateFormData(key, value)
    },
    /**
     * 刷新标单项
     * @param refCode
     */
    handleFormItemUpdate(refCode) {
      this.$refs.form.handleUpdate(refCode)
    },
    updateTitleData(key, value) {
      this.$refs.table.updateFormData(key, value)
    },
    /**
     * 更新表格
     */
    updateTable() {
      this.$refs.table.find()
    }
  }
}
</script>

<style scoped lang="scss">

</style>
